import { Component } from '@angular/core';
import { UserPaths } from '../../user/user-paths';

@Component({
  selector: 'app-access-denied',
  standalone: false,
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss'
})
export class AccessDeniedComponent {
  routes = UserPaths;
}
